import { render } from "./PokemonOption.vue?vue&type=template&id=e150fd98&scoped=true"
import script from "./PokemonOption.vue?vue&type=script&lang=js"
export * from "./PokemonOption.vue?vue&type=script&lang=js"

import "./PokemonOption.vue?vue&type=style&index=0&id=e150fd98&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\cursos\\udemy\\curso-vue-cero-experto\\04-pokemon-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e150fd98"]])

export default __exports__